import { _, Radio } from "../../../vendor";
import InboomaBaseView from "../InboomaBaseView";

import FacilitiesSidebarTpl from "../../templates/facilities/FacilitiesSidebarTpl.html";

// @todo If any kind of filter shall be used, add SidebarFilterBehavior
// as e.g. in OrdersSidebarView.js

export default InboomaBaseView.extend({
  template: FacilitiesSidebarTpl,
  el: "#inb-c-sidebar",

  ui: {
    toggleLeftBarFloatBtn: "#show-left-bar",
    addFacility: "#inb-c-left-bar-add-facility",
  },

  events: {
    "click @ui.toggleLeftBarFloatBtn": "_toggleLeftBar",
    "click .reset-collection": "_resetCollection",
  },

  templateContext: () => {
    return {
      facilities: Radio.channel("facilities").request("get:data").models,
      facility_slots: [], //Radio.channel('facility_slots').request('get:data').models,
    };
  },

  onRender() {
    this.$(".inb-filtered-facilities-count").html(this.collection.models.length);
  },

  initialize() {
    const that = this;

    this.collection.on("destroy", function () {
      that.render();
    });
  },
});
